import { render } from "./PowersSection.vue?vue&type=template&id=4667ecea"
import script from "./PowersSection.vue?vue&type=script&lang=js"
export * from "./PowersSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__